var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.33138,
    y: 0.71224,
    width: 31.3333,
    height: 31.3333,
    rx: 7.66667,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.666667
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0987 22.7763C28.846 24.103 27.7721 25.1138 26.4454 25.3033C24.3606 25.6192 20.8859 25.9983 16.9691 25.9983C13.1154 25.9983 9.64072 25.6192 7.49275 25.3033C6.16607 25.1138 5.09209 24.103 4.83939 22.7763C4.58669 21.3233 4.33398 19.1753 4.33398 16.522C4.33398 13.8686 4.58669 11.7206 4.83939 10.2676C5.09209 8.94092 6.16607 7.93011 7.49275 7.74058C9.57754 7.42471 13.0522 7.04565 16.9691 7.04565C20.8859 7.04565 24.2974 7.42471 26.4454 7.74058C27.7721 7.93011 28.846 8.94092 29.0987 10.2676C29.3514 11.7206 29.6673 13.8686 29.6673 16.522C29.6041 19.1753 29.3514 21.3233 29.0987 22.7763Z",
    fill: "#FF3D00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4414 20.9444V12.0999L22.0225 16.5221L14.4414 20.9444Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.cf60f5c116f3f7d520cd9203e1609901.svg";
export { ForwardRef as ReactComponent };